module.exports = __webpack_public_path__ + "img/d23.96fa76e3.png";